module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageCount > 1) ? _c('ul', {
    staticClass: "page"
  }, [_c('li', {
    staticClass: "page-item",
    class: {
      'page-disabled': _vm.currentPage === 1
    },
    on: {
      "click": _vm.prevPage
    }
  }, [_c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.prevText)
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      'page-current': _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        _vm.setCurrentPage(1)
      }
    }
  }, [_c('a', [_vm._v("1")])]), _vm._v(" "), (_vm.currentPage - 3 > 1) ? _c('li', {
    staticClass: "page-item page-disabled"
  }, [_c('a', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 2 > 1) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.currentPage - 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage - 1 > 1) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.currentPage - 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage - 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage != 1 && _vm.currentPage != _vm.pageCount) ? _c('li', {
    staticClass: "page-item page-current",
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.currentPage)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 1 < _vm.pageCount) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.currentPage + 1)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 1))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 2 < _vm.pageCount) ? _c('li', {
    staticClass: "page-item",
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.currentPage + 2)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.currentPage + 2))])]) : _vm._e(), _vm._v(" "), (_vm.currentPage + 3 < _vm.pageCount) ? _c('li', {
    staticClass: "page-item page-disabled"
  }, [_c('a', [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      'page-current': _vm.currentPage === _vm.pageCount
    },
    on: {
      "click": function($event) {
        _vm.setCurrentPage(_vm.pageCount)
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.pageCount))])]), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: {
      'page-disabled': _vm.currentPage === _vm.pageCount
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c18a1490","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Page.vue
// module id = 848
// module chunks = 0